// @flow

// Vendors
import React from 'react';

// Components
import { ProjectsGridItem, ProjectsGridItemPlaceholder } from '.';
import { LoadMore } from '../../components';

// Types
type Props = {};

const ProjectsGrid = ({
  projects,
  loadMoreProjects,
  hasLoadMore,
  itemHoverText,
  loadMoreLabel
}: Props) => (
  <>
    <section>
      <div className="project-grid">
        {projects.length > 0 &&
          projects.map(({ id, ...project }) => (
            <ProjectsGridItem
              key={id}
              project={project}
              hoverText={itemHoverText}
            />
          ))}

        {projects.length < 1 &&
          [1, 2, 3].map(item => <ProjectsGridItemPlaceholder key={item} />)}
      </div>
    </section>

    {hasLoadMore && (
      <LoadMore label={loadMoreLabel} onClick={loadMoreProjects} />
    )}
  </>
);

ProjectsGrid.defaultProps = {
  loadMoreLabel: 'Show More Projects'
};

export default ProjectsGrid;
